import React, { useEffect, useState } from "react";
import { Copy, RefreshCw, Link2 } from "lucide-react";
import { toast } from "sonner";
import { capacitacionAdminApi, apiError } from "../../../lib/api";
import { Input } from "../../ui/input";
import { Switch } from "../../ui/switch";

export const PublicTab = () => {
  const [s, setS] = useState(null);
  const [res, setRes] = useState([]);
  useEffect(() => {
    capacitacionAdminApi.settings().then(setS).catch((e) => toast.error(apiError(e)));
    capacitacionAdminApi.publicResults().then((d) => setRes(d.items)).catch(() => {});
  }, []);
  const save = async (p) => { try { setS(await capacitacionAdminApi.saveSettings(p)); toast.success("Guardado."); } catch (e) { toast.error(apiError(e)); } };
  if (!s) return null;
  const link = `${window.location.origin}/capacitacion`;

  return (
    <div className="space-y-6" data-testid="cap-public-tab">
      <div className="bg-white rounded-2xl ring-1 ring-black/5 p-5">
        <div className="font-extrabold text-[#0A1C30] flex items-center gap-2"><Link2 className="w-5 h-5 text-[#B99B2E]" /> Link público</div>
        <p className="text-sm text-[#6B7688] mt-1">Compártelo fuera de la app: incluye todo el contenido y las evaluaciones. Se pide nombre, correo, Referencia Supera y programa para registrar resultados. Puedes desactivarlo cuando quieras.</p>
        <div className="mt-3 flex flex-wrap gap-2">
          <Input readOnly value={link} data-testid="cap-public-link" className="flex-1 min-w-[260px]" />
          <button data-testid="cap-public-copy" onClick={() => { navigator.clipboard?.writeText(link); toast.success("Link copiado."); }} className="inline-flex items-center gap-2 rounded-xl bg-[#0A1C30] text-white font-bold px-4 text-sm"><Copy className="w-4 h-4" /> Copiar</button>
          <label className="flex items-center gap-2 text-sm font-bold px-2">Activo <Switch data-testid="cap-public-active" checked={s.publico_activo !== false} onCheckedChange={(v) => save({ publico_activo: v })} /></label>
        </div>
      </div>
      <div className="bg-white rounded-2xl ring-1 ring-black/5 p-5 flex flex-wrap items-center gap-4">
        <div className="flex-1 min-w-[240px]"><div className="font-extrabold text-[#0A1C30]">Recordatorio automático</div>
          <p className="text-sm text-[#6B7688]">Notificación + correo a quienes tienen la capacitación pendiente y no han tenido actividad.</p></div>
        <label className="flex items-center gap-2 text-sm">Horas sin actividad
          <Input type="number" className="w-20" defaultValue={s.horas_recordatorio} onBlur={(e) => save({ horas_recordatorio: Number(e.target.value) })} data-testid="cap-reminder-hours" /></label>
        <Switch data-testid="cap-reminder-auto" checked={s.recordatorio_auto} onCheckedChange={(v) => save({ recordatorio_auto: v })} />
      </div>
      <div className="bg-white rounded-2xl ring-1 ring-black/5 overflow-x-auto">
        <div className="px-5 pt-5 font-extrabold text-[#0A1C30]">Resultados del link público</div>
        <table className="w-full text-sm mt-3">
          <thead className="text-left text-xs text-[#6B7688] uppercase"><tr>{["Nombre", "Email", "Referencia", "Programa", "Módulo", "Nota", "Resultado", "Fecha"].map((h) => <th key={h} className="px-5 py-2">{h}</th>)}</tr></thead>
          <tbody>
            {res.map((r) => (
              <tr key={r.id} className="border-t border-black/5" data-testid={`cap-public-result-${r.id}`}>
                <td className="px-5 py-2 font-bold">{r.nombre}</td><td className="px-5 py-2">{r.email}</td><td className="px-5 py-2">{r.referencia || "—"}</td><td className="px-5 py-2">{r.programa || "—"}</td><td className="px-5 py-2">{r.capacitacion_titulo}</td>
                <td className="px-5 py-2">{r.nota}/{r.total}</td>
                <td className="px-5 py-2"><span className={`px-2 py-0.5 rounded-full text-xs font-bold ${r.aprobado ? "bg-[#E7F6EE] text-[#0F5132]" : "bg-[#FDECEC] text-[#842029]"}`}>{r.aprobado ? "Aprobado" : "No aprobado"}</span></td>
                <td className="px-5 py-2 text-xs">{new Date(r.created_at).toLocaleString("es-MX", { dateStyle: "short", timeStyle: "short" })}</td>
              </tr>
            ))}
            {!res.length && <tr><td colSpan={8} className="px-5 py-8 text-center text-[#6B7688]">Aún no hay resultados.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
